import { type ReactNode } from 'react';
import Box from '@liquidweb-dev/undercurrent/Box';
import Stack, { type StackProps } from '@liquidweb-dev/undercurrent/Stack';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

export interface PageLayoutAlertProps extends StackProps {
	children: ReactNode;
}

const PageLayoutAlert = ({ children, sx, ...rest }: PageLayoutAlertProps) => {
	return (
		<Box
			sx={combineSx(
				{
					paddingBottom: 400,
					paddingTop: 100,
				},
				sx,
			)}
			{...rest}
		>
			<Stack
				sx={{
					maxWidth: '1200px',
					marginX: 'auto',
					width: '100%',
				}}
			>
				{children}
			</Stack>
		</Box>
	);
};

export default PageLayoutAlert;
